import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const Baseinformation: RouteConfig = {
  path: '/base-information',
  component: Layout,
  redirect: 'noredirect',
  name: 'basicDataMenu',
  meta: {
    default: !0,
    permission: 'basicDataMenu',
    title: 'baseinformation',
    icon: 'peoples'
  },
  children: [{
    path: 'busy-manage/index',
    component: () => import(/* webpackChunkName: "lbBusiness" */ '@/views/baseinformation/busymanage/index.vue'),
    name: 'lbBusiness',
    meta: {
      title: 'busymanage',
      permission: 'lbBusiness',
      noCache: true,
      icon: 'base-busi'
    }
  },
  {
    path: 'major-manage/index',
    component: () => import(/* webpackChunkName: "lbSubject" */ '@/views/baseinformation/majormanage/index.vue'),
    name: 'lbSubject',
    meta: {
      title: 'majormanage',
      permission: 'lbSubject',
      noCache: true,
      icon: 'base-subject'
    }
  },
  {
    path: 'grade-manage/index',
    component: () => import(/* webpackChunkName: "lbGrade" */ '@/views/baseinformation/grademanage/index.vue'),
    name: 'lbGrade',
    meta: {
      title: 'grademanage',
      permission: 'lbGrade',
      noCache: true,
      icon: 'base-grade'
    }
  },
  {
    path: 'busyschool-manage/index',
    component: () => import(/* webpackChunkName: "businessSchool" */ '@/views/baseinformation/busyschoolmanage/index.vue'),
    name: 'businessSchool',
    meta: {
      title: 'busyschoolmanage',
      permission: 'businessSchool',
      noCache: true,
      icon: 'base-bschool'
    }
  },
  {
    path: 'schoolgrade-manage/index',
    component: () => import(/* webpackChunkName: "schoolGrade" */ '@/views/baseinformation/schoolgrademanage/index.vue'),
    name: 'schoolGrade',
    meta: {
      title: 'schoolgrademanage',
      permission: 'schoolGrade',
      noCache: true,
      icon: 'base-sgrade'
    }
  },
  {
    path: 'school-manage/index',
    component: () => import(/* webpackChunkName: "lbSchool" */ '@/views/baseinformation/schoolmanage/index.vue'),
    name: 'lbSchool',
    meta: {
      title: 'schoolmanage',
      permission: 'lbSchool',
      noCache: true,
      icon: 'base-school'
    }
  },
  {
    path: 'schoolmajor-manage/index',
    component: () => import(/* webpackChunkName: "schoolSubject" */ '@/views/baseinformation/schoolmajormanage/index.vue'),
    name: 'schoolSubject',
    meta: {
      title: 'schoolmajormanage',
      permission: 'schoolSubject',
      noCache: true,
      icon: 'base-ssubject'
    }
  },
  {
    path: 'studytype-manage/index',
    component: () => import(/* webpackChunkName: "studyMenu" */ '@/views/baseinformation/studytypemanage/index.vue'),
    name: 'studyMenu',
    meta: {
      title: 'studytypemanage',
      permission: 'studyMenu',
      noCache: true,
      icon: 'base-study'
    }
  }]
}

export default Baseinformation
